<template>
  <div class="stock-imports">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'StockImports'
  }
</script>